/* eslint-disable max-len */
import { motion } from 'framer-motion'
import React from 'react'

function EmptyWishlistScreen({selectedWishlist,cart}) {
    return (
        <motion.div
            animate={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: -10 }}
            exit={{ opacity: 0, x: -10 }}
            transition={{ duration: 0.15 }} className={`w-full flex flex-col justify-center items-center ${cart==='cart'?'h-customh2':'h-customh4'} px-2 text-center`}>
            <img src="/images/Group8022.svg" alt="icon" />
            <p className="lg:text-xs16 sm:text-xl text-sm font-normal text-[#15090E] sm:pt-[26px] pt-[14px] sm:pb-9 pb-5">It seems like there are <span className="text-[#ED1C24]">no products</span>{ cart==='cart'?' added to the cart yet!':' wishlisted yet!'}</p>
            <a href="/products">
                <button
                    type="button" className="sm:w-[314px] w-[280px] sm:h-12 h-9 bg-[#555259] rounded-lg sm:text-lg text-sm font-semibold text-[#FFFFFF]">
                    Add products to{cart==='cart'?' Cart ':' Wishlist'}
                </button>
            </a>
        </motion.div>
    )
}

export default EmptyWishlistScreen